import React, { useEffect, useState } from 'react';
import { formatAuditValue } from './fieldLabels';
import './EditRecordModal.css';

// Lista el historial de ediciones de un registro (quién, cuándo y qué cambió).
// fetchTrail: función async que regresa { success, data: [entries] }
const AuditTrailPanel = ({ fetchTrail, fieldLabels, refreshKey = 0 }) => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      try {
        const result = await fetchTrail();
        if (!cancelled) setEntries(result.data || []);
      } catch (error) {
        if (!cancelled) setEntries([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey]);

  if (loading) {
    return <p className="audit-trail-empty">Cargando historial de cambios...</p>;
  }

  if (entries.length === 0) {
    return <p className="audit-trail-empty">Este registro no tiene ediciones. Se muestra tal como se capturó originalmente.</p>;
  }

  return (
    <div className="audit-trail-list">
      {entries.map((entry) => (
        <div key={entry.id} className="audit-trail-entry">
          <div className="audit-trail-meta">
            <span className="audit-trail-doctor">Dr. {entry.doctor_nombre}</span>
            <span>{new Date(entry.created_at).toLocaleString('es-MX')}</span>
          </div>
          <ul className="audit-trail-changes">
            {Object.entries(entry.cambios || {}).map(([field, change]) => (
              <li key={field}>
                <strong>{(fieldLabels && fieldLabels[field]) || field}:</strong>{' '}
                <span className="confirm-value-before">{formatAuditValue(change.antes)}</span>
                {' → '}
                <span className="confirm-value-after">{formatAuditValue(change.despues)}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default AuditTrailPanel;
